import { Icon, IconDefinitions } from "../../../../components";

interface BreachBannerProps {
  breachLevel: "caution" | "critical";
  source?: "flaw" | "deviation" | "both";
}

const SOURCE_LABELS = {
  flaw: "Peak",
  deviation: "Rolling average deviation",
  both: "Peak and rolling average deviation",
};

export function BreachBanner({ breachLevel, source = "flaw" }: BreachBannerProps) {
  const isCritical = breachLevel === "critical";
  const subject = SOURCE_LABELS[source];
  const verb = source === "both" ? "have" : "has";

  return (
    <div
      className="w-100 mb-3 px-3 py-2 rounded-2 d-flex align-items-center gap-2"
      style={{
        backgroundColor: isCritical
          ? "rgba(192, 57, 43, 0.1)"
          : "rgba(241, 196, 15, 0.12)",
        border: `1px solid ${isCritical ? "rgba(192, 57, 43, 0.25)" : "rgba(241, 196, 15, 0.35)"}`,
      }}
    >
      <Icon
        iconName={IconDefinitions.warning}
        style={{
          color: isCritical ? "#c0392b" : "#f1c40f",
          fontSize: "1rem",
        }}
      />
      <small
        className="fw-semibold"
        style={{
          color: isCritical ? "#c0392b" : "#917608",
        }}
      >
        {subject} {verb} exceeded the {isCritical ? "critical" : "caution"} threshold
      </small>
    </div>
  );
}
